// removed by extract-text-webpack-plugin
module.exports = {"container":"unknown-error-message__container___3iC9w","inner":"unknown-error-message__inner___1bSz4","five-hundred":"unknown-error-message__five-hundred___2-weY","close":"unknown-error-message__close___3qRYX"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/common/unknown-error-message.scss
// module id = 1315
// module chunks = 0